// from my private project

import React from 'react'

class Inner extends React.Component {
  render() {
    const {
      children,
      visibleChild,
      closeModal,
      allowClose,
      innerStyle,
      ...props,
    } = this.props
    const style = {
      backgroundColor: "white",
      maxWidth: "80%",
      minWidth: "200px",
      position: "fixed",
      overflow: "auto",
      alignSelf: `center`,
      ...innerStyle,
    }
    const closeButtonStyle = {
      float: "right",
    }

    if (!allowClose) {
      return (
        <dialog
            style={style}
            onClick={e => {
              this.partialPropagation(e)
            }}
            open
            {...props}
        >
          {children[visibleChild] || children}
        </dialog>
      )
    }

    return (
      <dialog
          style={style}
          onClick={e => {
            this.partialPropagation(e)
          }}
          open
          {...props}
      >
        <button
            onClick={e => this.partialPropagation(e)}
            ref={node => {
              this.closeModalButton = node
            }}
            style={closeButtonStyle}
        >
          X
        </button>
        {children[visibleChild] || children}
        <div style={{clear: `both`}} />
      </dialog>
    )
  }

  partialPropagation(e) {
    if (e.target !== this.closeModalButton) {
      e.stopPropagation()
    }
  }
}

export default class Outer extends React.Component {
  render() {
    const {
      visibleChild,
      allowClose,
      onClose,
      show,
      outerStyle,
      ...props,
    } = this.props
    const style = {
      display: this.state.show ? "flex" : "none",
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      justifyContent: `center`,
      ...outerStyle,
    }

    if (!allowClose) {
      return (
        <div
            style={style}
        >
          <Inner
              visibleChild={visibleChild}
              allowClose={allowClose}
              {...props}
          />
        </div>
      )
    }

    return (
      <div 
          style={style}
          onClick={() => this.closeModal()}
      >
        <Inner
            visibleChild={visibleChild}
            allowClose={allowClose}
            {...props}
        />
      </div>
    )
  }

  constructor(props) {
    super(props)
    this.closeModal = this.closeModal.bind(this)
    this.handleEscKey = this.handleEscKey.bind(this)

    this.state = {
      show: props.show,
    }
  }

  componentDidMount() {
    document.addEventListener(`keyup`, this.handleEscKey)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: nextProps.show,
    })
  }

  componentWillUnmount() {
    document.removeEventListener(`keyup`, this.handleEscKey)
  }

  closeModal() {
    this.setState({
      show: false,
    })
    if (this.props.onClose) {
      this.props.onClose() 
    }
  }

  handleEscKey(e) {
    if (e.keyCode === 27) {
      this.closeModal()
    }
  }
}

Outer.propTypes = {
  visibleChild: React.PropTypes.number,
  show: React.PropTypes.bool,
  onClose: React.PropTypes.func,
  allowClose: React.PropTypes.bool,
}

Outer.defaultProps = {
  visibleChild: 0,
  show: true,
  allowClose: true,
}



// WEBPACK FOOTER //
// ./src/Modal.js